import classNames from 'classnames'
import React from 'react'

import { Box, type BoxProps } from '~/components/elements/Box'

import styles from './ZStack.css'

export type ZStackProps = BoxProps

export const ZStack = React.forwardRef<HTMLDivElement, ZStackProps>(
  (
    { className, 'data-testid': dataTestId = 'components-elements-z-stack', ...rest },
    ref,
  ) => (
    <Box
      ref={ref}
      className={classNames(styles.root, className)}
      data-testid={dataTestId}
      {...rest}
    />
  ),
)
